import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MapToolsMenuModel} from './map-tools-menu.model';

@Component({
  selector: 'app-map-tools-menu',
  templateUrl: './map-tools-menu.component.html',
  styleUrls: ['./map-tools-menu.component.scss'],
})
export class MapToolsMenuComponent<T> {
  @Input() toolMenuItems: Array<MapToolsMenuModel<T>>;
  @Output() chosenToolMenuItem = new EventEmitter<T>();

  chosenToolMenuItemEvent(id: T) {
    this.chosenToolMenuItem.emit(id);
  }
}
